module.exports = __webpack_public_path__ + "static/logo-cd1d53cd5ee820722ef023f2467d7b79.png";